import { Typography, Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import axiosInstance from "../util/axios_instance";

function JournalEntry() {
    const BACKEND_HOST = process.env.REACT_APP_BACKEND_HOST;
    let [journalEntry, setJournalEntry] = useState({})

    const location = useLocation();
    const { journal_id, entry_id } = location.state || {}; // Safe access in case state is undefined
    useEffect(() => {
        fetchData()
    }, [])

    const fetchData = async () => {
        try {
            const response = await axiosInstance.get(`${BACKEND_HOST}/journal/get_entry/${journal_id}/${entry_id}`, {
                withCredentials: true
            });
            setJournalEntry(response.data)
        } catch (err) {
            console.log(err)
        }
    }

    return (
        <Box display="flex"
            flexDirection={"column"}
            width="80vw" // Set width to 50% of the viewport width
            alignItems={'center'}
            justifyContent={'center'}
            margin={'auto'}
            marginTop={12}
            padding={3}
            borderRadius={5}
            boxShadow={"5px 10px 10px #ccc"}
            sx={{
                ":hover": {
                    boxShadow: "10px 10px 20px #ccc",
                }
            }}>
            <Typography variant='h2' padding={3} textAlign={'center'}>
                {journalEntry.title} </Typography>
            <Typography id="modal-description" sx={{ whiteSpace: 'pre-line' }}>
                {journalEntry.data}
            </Typography>
        </Box>
    )
}

export default JournalEntry;